import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  IGetProductDetails,
  IGetProductDetailsParams,
  IGetProductSEOData,
} from "./interfaces/api-product-details-interface";
import {
  IGetProductResult,
  IProductsGetAllParams,
  IProductsSearchParams,
  IProductsSearchResult,
} from "./interfaces/api-product-interfaces";

const URLs = {
  getProducts: "/products",
  search: "/products/search",
  SEOData: "/seo-data",
};
class ApiProducts extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getProducts = (params: IProductsGetAllParams): Promise<IGetProductResult> =>
    this.get(URLs.getProducts, { params });
  searchProducts = (
    params: IProductsSearchParams,
  ): Promise<IProductsSearchResult> => this.get(URLs.search, { params });
  getProductDetails = (
    params: IGetProductDetailsParams,
  ): Promise<IGetProductDetails> => {
    return this.get(URLs.getProducts + "/" + params.id, {});
  };
  getProductSEOData = (
    params: IGetProductDetailsParams,
  ): Promise<IGetProductSEOData> => {
    return this.get(`${URLs.getProducts}/${params.id}${URLs.SEOData}`, {});
  };
  toggleWishlist = (
    id: number,
    params?: { fbc?: string | null; fbp?: string | null; event_id?: string },
  ) => {
    return this.post(`/products/${id}/toggle-wishlist`, {}, { params });
  };
}
export default ApiProducts;
